import React from 'react'

import type { LucideIconName } from '~/core/ui/IconWrapper'
import IconWrapper from '~/core/ui/IconWrapper'
import { TypographyText } from '~/core/ui/Text'

function UniversalSearchItemView({
  iconName,
  label,
  rightText1,
  rightText2,
  type,
  selected
}: {
  iconName: LucideIconName
  label: string
  rightText1: string
  rightText2: string
  type: string
  selected: boolean
}) {
  return (
    <div className="relative flex h-[36px] cursor-pointer flex-row items-center py-2">
      <IconWrapper size={16} name={iconName} />
      <div className="ml-3 max-w-[580px] overflow-hidden text-ellipsis whitespace-nowrap">
        <TypographyText className="truncate text-sm font-medium text-gray-900">
          {label}
          <span className="ml-2 font-normal text-gray-600">{rightText1} </span>
          {rightText2 ? (
            <span className="mx-2 inline-block h-1 w-1 rounded-full bg-gray-400 align-middle" />
          ) : null}
          {rightText2 ? <span className="font-normal text-gray-600">{rightText2} </span> : null}
        </TypographyText>
      </div>
      {selected ? (
        <IconWrapper
          className="absolute right-2 top-2"
          size={16}
          color="#6B7280"
          name="CornerDownLeft"
        />
      ) : null}
    </div>
  )
}

export default UniversalSearchItemView
